import {Link} from 'gatsby'
import React, { Component } from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { cn, getPageUrl } from '../lib/helpers'
import Offer from '../components/offer'
import Container from '../components/container'

import * as styles from './dynamic-zone-component.module.css'

import Markdown from "react-markdown"

function DynamicZoneComponent ({component, index = "", anchor = ""}) {
  
  if (component.__typename == "STRAPI_ComponentContentListTopN"){
    return (
        <>
          <div><Container>
            <a id={anchor} href={"#"+anchor}></a>
              {component.page && 
              <Link to={"/"+component.page.slug} className={styles.subheading}>
                  <h2>{index}{component.title}</h2>
              </Link>
              }
              { !component.page && 
              <h2>{index}{component.title}</h2>
              }
              {component.introduction && 
                <Markdown children={component.introduction} skipHtml={true} />
              }
          </Container></div>
              {
                // main image if no children
                component.section_image &&
                <div className={styles.sectionImage}>
                    <GatsbyImage image={getImage(component?.section_image?.imageFile)} alt={component.section_image.alternativeText ? component.section_image.alternativeText : component.title } />
                    <div className={styles.sectionImageCopyright}>{component.section_image.caption}</div>
                </div>
                }
          <div><Container>
              <Markdown children={component.description} allowDangerousHtml />
            { component.offers && 
              component.offers.map(offer => (
                <span key={offer.id}><Offer offer={offer}></Offer></span>
              ))
            }
          </Container></div>
        </>
      )
  }
  if (component.__typename == "STRAPI_ComponentContentEmbeddedHtml"){
    return (
        <div className={styles.sectionEmbeded} dangerouslySetInnerHTML={{__html: component.raw_html }} />
    )
  }
  return (
    <>
        <h2>{component.__typename}</h2>
    </>
  )
}

DynamicZoneComponent.defaultProps = {
    props: {},
  }

export default DynamicZoneComponent
